function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.609,4.306c-6.666,-0.564 -12.629,4.42 -13.255,11.081l-2.735,-2.735l-1.648,1.648l4.839,4.839c0.458,0.439 1.19,0.439 1.648,0l4.804,-4.839l-1.648,-1.648l-2.946,2.981c0.463,-5.382 5.239,-9.449 10.626,-9.048c5.142,0.396 9.163,4.737 9.163,9.895c0,5.105 -3.939,9.42 -9.023,9.883c-0.608,0.037 -1.088,0.548 -1.087,1.157c-0.004,0.334 0.137,0.654 0.386,0.877c0.219,0.202 0.507,0.315 0.806,0.316l0.105,0c6.34,-0.491 11.295,-5.844 11.295,-12.202c0,-6.372 -4.976,-11.732 -11.33,-12.205Z",
    style: {
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.852,17.491c0,-0.635 -0.522,-1.157 -1.157,-1.157l-3.331,0l0,-4.559c0,-0.634 -0.523,-1.157 -1.157,-1.157c-0.635,0 -1.158,0.523 -1.158,1.157l0,5.716c0,0.635 0.523,1.157 1.158,1.157l4.488,0c0.635,0 1.157,-0.522 1.157,-1.157Z",
    style: {
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.3px"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pending.67e08a2f82b333e1bc41b4435434e81a.svg";